// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3psu_","errors":"Errors_errors__8-Hk2"};